var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUploadPrimary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.02952 0.52818C6.28977 0.268398 6.71122 0.268398 6.97147 0.52818L10.0191 3.5703C10.2797 3.83041 10.2801 4.25252 10.0199 4.51311C9.75983 4.77369 9.33772 4.77407 9.07714 4.51396L7.16716 2.60743L7.16716 8.96168C7.16716 9.32986 6.86868 9.62834 6.50049 9.62834C6.13231 9.62834 5.83383 9.32986 5.83383 8.96168L5.83383 2.60743L3.92386 4.51396C3.66327 4.77407 3.24116 4.77369 2.98105 4.51311C2.72093 4.25252 2.72131 3.83041 2.9819 3.5703L6.02952 0.52818ZM1.16667 8.46959C1.53486 8.46959 1.83333 8.76807 1.83333 9.13626V11.595C1.83333 11.8018 1.9116 11.9935 2.04077 12.1296C2.16881 12.2645 2.33479 12.3333 2.5 12.3333H10.5C10.6652 12.3333 10.8312 12.2645 10.9592 12.1296C11.0884 11.9935 11.1667 11.8018 11.1667 11.595V9.13626C11.1667 8.76807 11.4651 8.46959 11.8333 8.46959C12.2015 8.46959 12.5 8.76807 12.5 9.13626V11.595C12.5 12.1335 12.2973 12.6565 11.9264 13.0474C11.5543 13.4395 11.042 13.6667 10.5 13.6667H2.5C1.95797 13.6667 1.44567 13.4395 1.07361 13.0474C0.702683 12.6565 0.5 12.1335 0.5 11.595V9.13626C0.5 8.76807 0.798477 8.46959 1.16667 8.46959Z",
    fill: "#116584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUploadPrimary);
export default __webpack_public_path__ + "static/media/ic-upload-primary.e5c5f548ed7faef324c59a58e7ec2c96.svg";
export { ForwardRef as ReactComponent };